/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const json = require('./json');
const cells = require('./cells');
const cellborder = require('./cellborder');
const cellrange = require('./cellrange');
const copycells = require('./copycells');
const paste = require('./paste');
const sheet = require('./sheet');


module.exports = {
	...cells,
	...cellborder,
	...cellrange,
	...copycells,
	...json,
	...paste,
	...sheet
};
